import { ServiceClient } from 'src/utils'
import { ExportDocumentsResponse } from 'src/components/exportdocuments/export_documents_scope'
import { GroupRow } from '../admin/group-manager/gm_scopes'
import { AggMesAnoHistoryRow, ExportHistoryRow, HistoryQueryFilter, HistoryResponse } from './gp_scopes'

const serviceClient = ServiceClient.singleton()

export class GroupProfileService {
    static #INSTANCE = new GroupProfileService()
    static readonly singleton = () => GroupProfileService.#INSTANCE

    async myGroup(): Promise<GroupRow> {
        const data = await serviceClient.authGet<GroupRow>('/api/group-profile/myGroup')
        return data
    }

    async fetchProfile(groupId: number): Promise<GroupRow> {
        const data = await serviceClient.authGet<GroupRow>(`/api/group-profile/${groupId}`)
        return data
    }

    async updateBlockExportWhenExceeded(groupId: number, value: boolean): Promise<void> {
        await serviceClient.authPut(`/api/group-profile/${groupId}/block-export-when-exceeded`, { value })
    }

    async fetchHistory(groupId: number, query: HistoryQueryFilter): Promise<HistoryResponse<ExportHistoryRow>> {
        const queryParams = new URLSearchParams()
        query.startMonth && queryParams.append('startMonth', query.startMonth?.toString() || '')
        query.endMonth && queryParams.append('endMonth', query.endMonth?.toString() || '')
        query.page && queryParams.append('page', query.page.toString())
        query.limit && queryParams.append('limit', query.limit.toString())

        const data = await serviceClient.authGet<HistoryResponse<ExportHistoryRow>>(
            `/api/group-profile/${groupId}/monthly-export-history?${queryParams.toString()}`
        )
        return data
    }

    async fetchExportDocuments(
        groupId: number,
        exportId: number,
        query: { page: number; limit: number }
    ): Promise<ExportDocumentsResponse> {
        const queryParams = new URLSearchParams()
        queryParams.append('page', (query.page || 0).toString())
        queryParams.append('limit', (query.limit || 10).toString())

        const data = await serviceClient.authGet<ExportDocumentsResponse>(
            `/api/group-profile/${groupId}/export/${exportId}/documents?${queryParams.toString()}`
        )
        return data
    }

    async fetchChartHistory(
        groupId: number,
        query: HistoryQueryFilter,
        agg_types?: string[]
    ): Promise<HistoryResponse<AggMesAnoHistoryRow>> {
        const queryParams = new URLSearchParams()
        query.startMonth && queryParams.append('startMonth', query.startMonth?.toString() || '')
        query.endMonth && queryParams.append('endMonth', query.endMonth?.toString() || '')
        query.page && queryParams.append('page', query.page.toString())
        query.limit && queryParams.append('limit', query.limit.toString())
        agg_types && agg_types.length > 0 && queryParams.append('types', agg_types.join(','))

        const data = await serviceClient.authGet<HistoryResponse<AggMesAnoHistoryRow>>(
            `/api/group-profile/${groupId}/aggregate-export-history?${queryParams.toString()}`
        )
        return data
    }
}

export default GroupProfileService.singleton()
